export const GET_PROFILE_REQUESTING = 'GET_PROFILE_REQUESTING';
export const GET_PROFILE_REQUEST_SUCCESS = 'GET_PROFILE_REQUEST_SUCCESS';
export const GET_PROFILE_REQUEST_ERROR = 'GET_PROFILE_REQUEST_ERROR';

export const BANK_ACC_REQUESTING = 'BANK_ACC_REQUESTING';
export const BANK_ACC_REQUEST_SUCCESS = 'BANK_ACC_REQUEST_SUCCESS';
export const BANK_ACC_REQUEST_ERROR = 'BANK_ACC_REQUEST_ERROR';

export const SET_DEFAULT_REQUESTING = 'SET_DEFAULT_REQUESTING';
export const SET_DEFAULT_REQUEST_SUCCESS = 'SET_DEFAULT_REQUEST_SUCCESS';
export const SET_DEFAULT_REQUEST_ERROR = 'SET_DEFAULT_REQUEST_ERROR';
